module.exports = __webpack_public_path__ + "c592e79858a65e1514bf67d0f88109d8.png";